import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useEvaluationCache } from './cache'
import { type EvaluationRemoveInput, type EvaluationRemoveSuccess, Logger, toResponseError } from '@terros/common'

const logger = new Logger('useEvaluations')

export function useRemoveEvaluation(): RemoveHookResponse<EvaluationRemoveInput> {
  logger.verbose('calling useRemoveEvaluation')
  const cache = useEvaluationCache()
  const mutation = useTantalimMutation<EvaluationRemoveInput, EvaluationRemoveSuccess>({
    url: '/evaluation/remove',
  })

  async function remove(input: EvaluationRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearList()
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
